import { render, staticRenderFns } from "./ContentHeader.vue?vue&type=template&id=b284ec46&scoped=true"
import script from "./ContentHeader.vue?vue&type=script&lang=js"
export * from "./ContentHeader.vue?vue&type=script&lang=js"
import style0 from "./ContentHeader.vue?vue&type=style&index=0&id=b284ec46&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b284ec46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b284ec46')) {
      api.createRecord('b284ec46', component.options)
    } else {
      api.reload('b284ec46', component.options)
    }
    module.hot.accept("./ContentHeader.vue?vue&type=template&id=b284ec46&scoped=true", function () {
      api.rerender('b284ec46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ContentHeader/ContentHeader.vue"
export default component.exports